import React from 'react';
import t from 'shared/utils/translation';
import Button from '@grnhse/seedling/lib/azalea/components/button';

export function ConfigureExtensionAction({ setIsEditing }) {
  return (
    <Button
      onClick={() => {
        setIsEditing(true);
      }}
    >
      {t('gdpr.consent_extension_email.configure')}
    </Button>
  );
}
